module.exports = __webpack_public_path__ + "static/media/slack_notification.32eb6201.svg";